var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.316,
    height: 35.929,
    viewBox: "0 0 51.316 35.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube_1_",
    "data-name": "youtube (1)",
    d: "M50.259-.46a6.429,6.429,0,0,0-4.523-4.523c-4.016-1.1-20.078-1.1-20.078-1.1S9.6-6.082,5.58-5.025A6.559,6.559,0,0,0,1.057-.46C0,3.555,0,11.883,0,11.883s0,8.369,1.057,12.343A6.43,6.43,0,0,0,5.58,28.748c4.058,1.1,20.078,1.1,20.078,1.1s16.062,0,20.078-1.057a6.429,6.429,0,0,0,4.523-4.523c1.056-4.016,1.056-12.343,1.056-12.343s.042-8.37-1.057-12.385ZM20.544,19.576V4.19L33.9,11.883Zm0,0",
    transform: "translate(-0.001 6.082)",
    fill: "#20404a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c8c5112e9b5eef87edd84d4b5f744a14.svg";
export { ForwardRef as ReactComponent };